import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-simple-stat',
  templateUrl: './simple-stat.component.html',
  styleUrls: ['./simple-stat.component.scss']
})
export class SimpleStatComponent implements OnInit {

  @Input() customStyle: string | undefined;
  @Input() mainContent: string = "";
  @Input() secondary: string = "";
  @Input() count: number = -1;
  @Input() disabled: boolean = false;
  @Input() backgroundClass: string = "";
  @Input() isNew: boolean = false
  @Input() newTagPosition: "inline" | "below" = "inline";

  constructor() {
  }

  ngOnInit(): void {
  }
}
